import React, { useEffect, useState } from "react";
import "./styles/SettingsPage.css";
import { LinearGradient } from "react-text-gradients";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import {
  collapseSidebar,
  expandSidebar,
} from "../../../store/reducers/sidebarSlice";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { firestoreCollections } from "../../../utils";
import { db } from "../../../config/firebase";
import {
  errorToast,
  infoToast,
  successToast,
} from "../../../services/toastService";
import { ThreeDotLoader } from "../../Common/Loaders";

const EachMerchantRow = ({ index, merchant }) => {
  const [submitInactive, setSubmitInactive] = useState(true);
  const [submitCommissionLoading, setSubmitCommissionLoading] = useState(false);
  const [commissionValue, setCommissionValue] = useState(
    merchant.projectFeesToAdmin
  );

  useEffect(() => {
    if (commissionValue == merchant.projectFeesToAdmin || !commissionValue)
      setSubmitInactive(true);
    else setSubmitInactive(false);
  }, [commissionValue, merchant.projectFeesToAdmin]);

  const handleSubmitCommission = async () => {
    if (submitInactive) infoToast("Please change commission value to submit.");
    else {
      try {
        setSubmitCommissionLoading(true);
        const merchRef = doc(db, firestoreCollections.merchants, merchant.id);
        const updatedData = { projectFeesToAdmin: commissionValue };
        await updateDoc(merchRef, updatedData);
        successToast("Merchant updated successfully.");
      } catch (error) {
        errorToast("Internal server error");
        console.log(error, "<<< error approving merchant");
      } finally {
        setSubmitCommissionLoading(false);
      }
    }
  };

  return (
    <div className="verificationTableRow">
      <div
        style={{ width: "6%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {index}
      </div>
      <div
        style={{
          width: "15%",
          height: "100%",
          textDecoration: "underline",
          whiteSpace: "nowrap",
        }}
        className="eachColumn eachTableBody"
      >
        {merchant.displayName}
      </div>
      <div
        style={{ width: "15%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {merchant.phoneNumber}
      </div>
      <div
        style={{ width: "15%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {merchant?.category[0].name}
      </div>

      <div
        style={{ width: "15%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {merchant.accountType}
      </div>
      <div
        style={{
          width: "16%",
          height: "100%",
          textDecoration: "underline",
          color: "#3366CC",
        }}
        className="eachColumn eachTableBody"
      >
        <input
          style={{
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            color: "#565656",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            fontSize: "1.8vh",
            textAlign: "center",
          }}
          type="number"
          maxLength={2}
          defaultValue={merchant.projectFeesToAdmin}
          onChange={e => setCommissionValue(e.target.value)}
          placeholder="Enter Commission here"
        />
      </div>
      <div
        style={{
          width: "13%",
          height: "100%",
          textDecoration: "underline",
          color: submitInactive ? "#56565699" : "#3366CC",
        }}
        className="eachColumn eachTableBody"
        onClick={handleSubmitCommission}
      >
        {submitCommissionLoading ? (
          <ThreeDotLoader visible={true} color="#3366CC" />
        ) : (
          "submit"
        )}
      </div>
    </div>
  );
};

export default function CommissionScreen() {
  const sidebar = useSelector(state => state.sidebar);
  const dispatch = useDispatch();
  const [timeFrame, setTimeFrame] = useState("Day");
  const [merchantList, setMerchantList] = useState([]);

  const fetchVerifiedMerchants = () => {
    const q = query(
      collection(db, firestoreCollections.merchants),
      where("verified", "==", true)
    );

    const unsubscribe = onSnapshot(q, async querySnapshot => {
      const newData = await Promise.all(
        querySnapshot.docs.map(async profileDoc => {
          const merchantData = profileDoc.data();
          merchantData.category = await Promise.all(
            merchantData.category.map(async categId => {
              const categoryDoc = await getDoc(
                doc(db, firestoreCollections.merchantCategories, categId)
              );
              if (categoryDoc.exists()) {
                const data = categoryDoc.data();
                data.id = categoryDoc.id;
                return data;
              }
            })
          );
          console.log("snapshot run");
          return {
            ...merchantData,
            id: profileDoc.id,
          };
        })
      );

      setMerchantList(newData);
    });

    return unsubscribe; // Return the unsubscribe function to detach the listener when needed
  };

  useEffect(() => {
    const unsubscribe = fetchVerifiedMerchants();

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer"
      >
        {/* upper search bar start */}

        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <input placeholder="Search..." className="upperBarSearchBarInput" />
          </div>
          <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div>
          <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div>
        </div>

        {/* page heading start */}

        <div className="pageHeadingContainer">
          <div className="pageHeadingInnerContainer">
            <img
              src={require("../../../assets/dashboardColourIcon.png")}
              alt="profile-pic"
              className="pageHeadingImageDashboard"
            />
            <div className="pageHeading">
              <LinearGradient gradient={["to left", "#03BAF9,#7B32EE"]}>
                Commissions
              </LinearGradient>
            </div>
          </div>
          <div className="pageHeadingSecondaryText">Settings/General</div>
        </div>
        {/* general numbers container start */}

        <div className="verificationTableContainer">
          <div className="verificationTableRow">
            <div
              style={{ width: "6%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Sr. No.
            </div>
            <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Name
            </div>
            <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Phone Number
            </div>
            {/* <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Date Joined
            </div> */}
            <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Category
            </div>
            <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Type
            </div>
            <div
              style={{ width: "16%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Commission %
            </div>
            <div
              style={{ width: "13%", height: "100%" }}
              className="eachColumn eachTableHead"
            ></div>
          </div>
          {merchantList.map((merchant, i) => (
            <EachMerchantRow key={i} merchant={merchant} index={i + 1} />
          ))}

          {/* <EachMerchantRow />
          <EachMerchantRow /> */}
        </div>
      </div>
    </div>
  );
}
